import TermsAndConditionsModal from "./TermsAndConditionsModal";

export default TermsAndConditionsModal;
